import { TActiveIntegrationTypes } from '@/core/modules/integrations/integrations'
import { Separator } from '@/ui/components/separator/separator.styles'
import { FC, ReactElement } from 'react'
import { CsSteps } from './csSteps'
import { Title, Wrapper } from './integrationSteps.styles'

const stepByIntegrationType: Partial<
    Record<TActiveIntegrationTypes, ReactElement>
> = {
    crowdstrike: <CsSteps />,
}

type TIntegrationStepsProps = {
    integrationType: TActiveIntegrationTypes
}

export const IntegrationSteps: FC<TIntegrationStepsProps> = ({
    integrationType,
}) => {
    return (
        <Wrapper>
            <Separator />
            <Title variant="l-regular" component="p">
                Steps to enable
            </Title>
            {stepByIntegrationType[integrationType]}
        </Wrapper>
    )
}

export default IntegrationSteps
